<div class="paginator-wrapper" *transloco="let t">
  <div class="left-section">
    <span class="label">{{ t('table.pagination.showPerPage') }}</span>
    <p-select
      [options]="rowsPerPageOptions"
      [ngModel]="rows"
      optionLabel="label"
      optionValue="value"
      (ngModelChange)="onRowsChange({value: $event})"
      [placeholder]="rows.toString()"
      [ariaLabel]="t('table.pagination.showPerPage')"
    ></p-select>
  </div>

  <div class="right-section">
    <span class="current-page">{{first + 1}} - {{Math.min(first + rows, totalRecords)}} {{ t('table.pagination.of') }} {{totalRecords}}</span>
    <button 
      class="nav-button prev" 
      [disabled]="first === 0"
      (click)="previousPage()"
      [attr.aria-label]="t('common.a11y.previousPage')"
    >
      <lucide-icon name="ChevronLeft" aria-hidden="true"></lucide-icon>
    </button>
    <button 
      class="nav-button next" 
      [disabled]="first + rows >= totalRecords"
      (click)="nextPage()"
      [attr.aria-label]="t('common.a11y.nextPage')"
    >
      <lucide-icon name="ChevronRight" aria-hidden="true"></lucide-icon>
    </button>
  </div>
</div>